/* Auto-slide the Featured products (Balance theme) */
(() => {
  const INTERVAL_MS = 3500;   // advance every 3.5s
  const RESUME_DELAY = 1500;  // resume after user swipe

  // Find the Featured section (works with Balance wording/markup)
  const featuredSections = [
    ...document.querySelectorAll('.shopify-section')
  ].filter(sec =>
    sec.querySelector('.featured-collection') ||                      // common container
    (sec.id && /featured/i.test(sec.id)) ||                           // id contains 'featured'
    /featured/i.test((sec.querySelector('h2,h3')?.textContent) || '') // heading says 'Featured'
  );

  if (!featuredSections.length) return;

  featuredSections.forEach(section => {
    // Balance/Dawn variants of the horizontal scroller
    const scroller =
      section.querySelector('.slider') ||
      section.querySelector('.flickity-viewport') ||
      section.querySelector('.grid--peek') ||
      section.querySelector('.grid');

    if (!scroller) return;
    if (scroller.scrollWidth <= scroller.clientWidth + 8) return; // nothing to scroll

    // Figure out the step: one card width + gap
    const first =
      section.querySelector('.grid__item') ||
      section.querySelector('.slider__slide') ||
      section.querySelector('.card') ||
      scroller.firstElementChild;
    if (!first) return;

    const getGap = () => {
      const s = getComputedStyle(scroller);
      // Balance uses CSS gap on grid/slider
      const gap =
        parseFloat(s.columnGap || s.gap || '0') ||
        parseFloat(getComputedStyle(first).marginRight || '0') || 0;
      return isNaN(gap) ? 0 : gap;
    };

    const stepWidth = () => first.getBoundingClientRect().width + getGap();

    let timer = null;

    const advance = () => {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      const next = scroller.scrollLeft + stepWidth();
      scroller.scrollTo({ left: next >= maxScroll ? 0 : next, behavior: 'smooth' });
    };

    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };

    const start = () => {
      stop();
      // Respect users who prefer reduced motion
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(advance, INTERVAL_MS);
    };

    // Pause on user interaction, resume shortly after
    const pauseThenResume = () => {
      stop();
      setTimeout(start, RESUME_DELAY);
    };

    scroller.addEventListener('touchstart', pauseThenResume, { passive: true });
    scroller.addEventListener('touchend',   pauseThenResume, { passive: true });
    scroller.addEventListener('pointerdown', pauseThenResume);
    scroller.addEventListener('pointerup',   pauseThenResume);

    // Pause when tab is hidden
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));

    // Kick off
    start();
  });
})();
